import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeRichHtml } from '../utils/rich-html.util';

const HTML_PATTERN = /<\/?[a-z][^>]*>|&(?:#\d+|#x[\da-f]+|[a-z]+);/i;

/**
 * Renders question/option/explanation HTML from the API exactly as authored.
 * Angular's default [innerHTML] sanitizer strips inline styles (table borders,
 * cell widths, image sizing), so the HTML is sanitized with sanitizeRichHtml
 * and then trusted. Plain text is escaped so stray "<" characters stay visible.
 */
@Pipe({
  name: 'richHtml',
  standalone: true,
})
export class RichHtmlPipe implements PipeTransform {
  private readonly domSanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    if (!value) {
      return '';
    }
    const html = HTML_PATTERN.test(value) ? sanitizeRichHtml(value) : escapeHtml(value);
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
}

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
